export enum ErrorCode {
  'E00',    // Operation failed but do not notify user
  'E01',    // Operation failed and need to notify user
  'E02',    // Operation partially failed and doesn't need to notify user (when we can live with that failure..)
  'E03',    // Operation partially failed and may need to notify user (eg. Server updated but not local)
}
